/**
 * Accessible (WCAG 2.2 AA) overrides for the primary B4B theme.
 *
 * These values are spread on top of the base bfbTheme when high-contrast
 * mode is active.  Only colour properties that fail the 4.5:1 contrast
 * ratio (or whose fade/bg variants rely on opacity) are listed here;
 * everything else is inherited from the base theme.
 *
 * Source: Color Palette_Primary (Accessibility).pdf by Jess.
 */
const a11yOverrides = {
  // Hyperlink: #0FC5D8 → #067B87
  hyperlink: '#067B87',
  hyperlinkLigth: 'rgba(6, 123, 135, 0.4)',
  hyperlinkBgFade: 'rgba(6, 123, 135, 0.08)',

  // Entrepreneur green: #37CC82 → #1F7F4F
  memberGreen: '#1F7F4F',
  memberGreenHover: '#165c3a',
  memberGreenFade: 'rgba(31, 127, 79, 0.5)',
  memberGreenBgFade: 'rgba(31, 127, 79, 0.08)',
  applicationGreen: '#1A754E',

  // Mentor blue: #5185E0 → #426EBB
  mentorBlue: '#426EBB',
  mentorBlueHover: '#2f4e85',
  mentorBlueFade: 'rgba(66, 110, 187, 0.5)',
  mentorBlueBgFade: 'rgba(66, 110, 187, 0.1)',

  // Grey: #999999 → #6F6F6F
  grey: '#6a6a6a',
  greyBgFade: '#6a6a6a1a',

  // Placeholder grey: #B3B3B3 → #6F6F6F
  placeholderGrey: '#6F6F6F',

  // Error: #F25A5A → #E02D2D
  error: '#E02D2D',
  errorHover: '#a11f1f',
  errorFade: 'rgba(224, 45, 45, 0.5)',
  errorBg: '#E02D2D1A',

  // Warning: keep #F4D811 bg but ensure text is black, remove opacity
  warningBgFade: '#F4D81148',

  // Waitlist / follow-up colors — accessible replacements
  primaryWaitlistColor: '#2121CE',
  primaryWaitlistColorBg: '#2121CE1A',
  followUpColor: '#3E4612',
  followUpColorBg: '#3E46121A',
  lightbrown: '#99640B',
  lightOrange: '#CC3000',
  orange: '#CC3000',
  crimson: '#89043D',
  crimsonBgFade: '#89043D1A',
  // Parrot pink: #E82E81 → #B5245E
  parrotPink: '#B5245E',
  parrotPinkHover: '#6E0E3A',
  parrotPinkFade: 'rgba(181, 36, 94, 0.5)',
  parrotPinkBgFade: 'rgba(181, 36, 94, 0.06)',

  // Teal (radio/checkbox): #00FFAF → #067B87 (4.59:1 on white, meets 3:1 non-text AA)
  teal: '#067B87',

  brightLilac: '#8407E5',
  lilac: '#8407E5',

  // Yellow: #FDB833 → #99640B (as text color)
  yellow: '#99640B',
  yellowBgFade: '#99640B1a',
  lightYellow: '#99640B',
  lightYellowBgFade: 'rgba(153, 100, 11, 0.1)',
};

export default a11yOverrides;
